import { render } from "./Gov.vue?vue&type=template&id=e5466f58"
import script from "./Gov.vue?vue&type=script&lang=js"
export * from "./Gov.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__